import { styled, Button, Tooltip } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import FlexBox from 'components/flexbox/FlexBox';
import SearchInput from 'components/input-fields/SearchInput';
import React from 'react';
import axiosInstance from 'utils/axios';
import * as FileSaver from 'file-saver';
import { Download } from '@mui/icons-material';
const SecondaryWrapper = styled(FlexBetween)(({ theme }) => ({
    gap: 8,
    flexWrap: 'wrap',
    margin: '24px 0',
    [theme.breakpoints.down(550)]: {
        '& .MuiInputBase-root': {
            maxWidth: 'calc(100% - 90px)',
        },
    },
})); // --------------------------------------------------------------------

// --------------------------------------------------------------------
const SearchArea = ({
    value,
    onChange,
    setValue,
    typeId,
}) => {
    return (
        <SecondaryWrapper>
            <SearchInput
                placeholder="Search..."
                value={value || ''}
                onChange={(e) => {
                    if (onChange && setValue) {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }

                    onChange(e.target.value);
                }}
            />

            <FlexBox alignItems="center" gap={1}>
                <Tooltip title="Download Data">
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ cursor: 'pointer', fontSize: 14 }}
                        endIcon={<Download />}
                        onClick={async () => {
                            try {
                                const res = await axiosInstance.get(
                                    '/api/prv/operator-submissions/download',
                                    {
                                        params: {
                                            status: 'rejected',
                                            type_id: typeId,
                                        },
                                        responseType: 'blob',
                                    },
                                );
                                const blob = new Blob([res.data], {
                                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                });
                                FileSaver.saveAs(blob, 'Rejected Abstract.xlsx');
                            } catch (err) {
                                console.log(err);
                            }
                        }}
                    >
                        Download Data
                    </Button>
                </Tooltip>
            </FlexBox>
        </SecondaryWrapper>
    );
};

export default SearchArea;
